// // src/plugins/sales-forecast/clusterConfig.ts

// export const centroids: number[][] = [
//   // Cluster 0 – Amenity-Free Urban Core
//   [0.0, 0.0, 0.03, 0.0, 0.0, 0.02, 0.01],
//   // Cluster 1 – Leisure-Oriented Family Communities
//   [0.69, 0.08, 0.31, 1.0, 0.85, 0.38, 0.27],
//   // Cluster 2 – Premium Estate-Style Retreats
//   [1.0, 0.67, 0.42, 0.25, 0.0, 0.25, 0.21],
//   // Cluster 3 – Recreational Minimalist Suburbs
//   [0.0, 1.0, 0.07, 0.0, 0.0, 0.0, 0.02]
// ];

// export interface ClusterInfo {
//   name: string;
//   description: string;
// }

// export const clusterInfo: Record<number, ClusterInfo> = {
//   0: {
//     name: "Essential Living Neighborhoods",
//     description:
//       "Focused on simplicity and functionality, these communities offer streamlined living with little to no shared amenities. Ideal for buyers seeking affordability and a no-frills, low-maintenance lifestyle in dense or urban areas."
//   },
//   1: {
//     name: "Vibrant Lifestyle Communities",
//     description:
//       "Designed for families and active households, these neighborhoods feature pools, ponds, clubhouses, and a range of recreational amenities. The atmosphere is energetic, social, and amenity-rich—perfect for those seeking fun and connection close to home."
//   },
//   2: {
//     name: "Prestige Natural Estates",
//     description:
//       "These refined neighborhoods combine large private lots with scenic pond views and secure gated entries. They offer a tranquil and prestigious setting where natural beauty meets elevated living, appealing to buyers who value space and quiet sophistication."
//   },
//   3: {
//     name: "Wide-Open Quiet Retreats",
//     description:
//       "Spacious and serene, these communities boast large lots with minimal community infrastructure. With few to no shared amenities, they appeal to buyers who prioritize privacy, land, and a peaceful suburban environment."
//   }
// };

// src/plugins/sales-forecast/clusterConfig.ts

export const centroids: number[][] = [
  // Cluster 0 – Practical Cityside Classics
  [0.0476, 0.0, 0.0476, 0.0, 0.0, 0.0, 0.0, 0.2236, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0],
  // Cluster 1 – Urban Access Communities
  [-0.0, 0.0, 0.0182, 0.0, 0.0, 0.0273, 0.0182, 0.2236, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 0.0],
  // Cluster 2 – Luxury Nature Estates
  [0.3333, 0.0, 0.6667, 0.6667, 0.6667, 0.1667, 0.0833, -4.4721, 1.0, 0.0, 0.0, 0.0, 0.8333, 0.1667, 0.0],
  // Cluster 3 – Expansive Rural Havens
  [0.0, 1.0, 0.0769, 0.0, 0.0, 0.0, 0.0, 0.2236, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0],
  // Cluster 4 – Resort-Like Prestige Enclaves
  [1.0, 1.0, 0.4444, 0.4444, 0.1111, 0.0556, 0.0556, 0.2236, 0.0, 0.0, 0.8889, 0.1111, 0.0, 0.0, 1.0],
  // Cluster 5 – Traditional Retreats with Room to Grow
  [0.0, 0.25, 0.0, 0.0, 0.0, 0.0, 0.0, 0.2236, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0],
  // Cluster 6 – Minimalist City Dwellings
  [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.2236, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 0.0],
  // Cluster 7 – Amenity-Rich Family Communities
  [0.6667, 0.0, 0.1667, 1.0, 1.0, 0.4167, 0.0833, 0.2236, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 0.0],
  // Cluster 8 – Active Lifestyle Subdivisions
  [1.0, 0.0, 0.2, 0.4, 0.0, 0.8, 0.4, 0.2236, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 0.0]
];

export interface ClusterInfo {
  name: string;
  description: string;
}

export const clusterInfo: Record<number, ClusterInfo> = {
  0: {
    name: "Practical Cityside Classics",
    description:
      "These neighborhoods reflect a practical, no-frills approach to living. While they feature minimal shared amenities, they make up for it with consistent front-facing garages and efficient layouts. Perfect for buyers seeking functionality and affordability in a conventional urban setting with half-acre lots for more breathing room."
  },
  1: {
    name: "Urban Access Communities",
    description:
      "These compact neighborhoods are geared toward convenience-minded homeowners. Dominated by city lots and front-entry garages, they offer essential recreational features for active residents without excess. A top choice for buyers who value proximity and simplicity over bells and whistles."
  },
  2: {
    name: "Luxury Nature Estates",
    description:
      "These are high-end communities that boast premium natural surroundings—ponds, gates, pools, and clubhouses—all with the rare inclusion of COTTAGE-style garages and urban lot access. Despite the unusual negative scaling in garage spaces (likely due to preprocessing), these neighborhoods clearly emphasize prestige, beauty, and recreational amenities in scenic environments."
  },
  3: {
    name: "Expansive Rural Havens",
    description:
      "These neighborhoods are defined by their large lot sizes and front-facing garages. With minimal amenity overhead, they’re ideal for homeowners who prioritize land, privacy, and flexibility—often found on the outskirts of the urban footprint."
  },
  4: {
    name: "Resort-Like Prestige Enclaves",
    description:
      "Packed with nearly every sought-after feature—ponds, large lots, gates, pools, and SIDE-entry garages—these communities offer high prestige without being overbuilt. Ideal for buyers who desire luxury living with space and quiet elegance."
  },
  5: {
    name: "Traditional Retreats with Room to Grow",
    description:
      "These neighborhoods offer large lots and straightforward home layouts with front-entry garages. While they lack shared amenities, the abundance of private space and classic design appeals to homeowners seeking peace, expansion potential, and practical living."
  },
  6: {
    name: "Minimalist City Dwellings",
    description:
      "Stripped to the essentials, these communities forgo shared amenities entirely. They emphasize urban lots and standard front-entry garages, making them perfect for city-minded buyers who value simplicity, convenience, and low maintenance overhead."
  },
  7: {
    name: "Amenity-Rich Family Communities",
    description:
      "These vibrant neighborhoods are playgrounds for families—offering pools, ponds, clubhouses, and recreational areas. With practical garage designs and city-lot footprints, they strike a balance between suburban charm and urban accessibility."
  },
  8: {
    name: "Active Lifestyle Subdivisions",
    description:
      "With standout recreation support—including high kids’ and adults’ amenity prevalence—these neighborhoods are hubs for active families and social homeowners. Their city-lot layout and front garages keep them efficient, while ponds and playgrounds add charm and fun."
  }
};